import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@decisiv/ui-components/lib/components/Modal';
import { P } from '@decisiv/ui-components';
import { t, Trans } from '@lingui/macro';
import noop from 'lodash/noop';
import WrapperWithLoading from '../../../components/WrapperWithLoading';

export default function AddMultipleLocations({
  visible = false,
  isPosting = false,
  onClose,
  setRefresh = noop,
}) {
  return (
    <>
      <Modal
        title={t`Processing ...`}
        onClose={() => {
          onClose();
          setRefresh(true);
        }}
        visible={visible && !isPosting}
      >
        <P shade={1} marginTop={2}>
          <Trans>
            You may close this window and continue working. We will notify you
            when the process is complete.
          </Trans>
        </P>
      </Modal>

      <Modal visible={visible} title="">
        <WrapperWithLoading loading={isPosting} title={t`Processing ...`} />
      </Modal>
    </>
  );
}

AddMultipleLocations.propTypes = {
  visible: PropTypes.bool,
  isPosting: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  setRefresh: PropTypes.func,
};
